'use es6';

export const getPreviewerWindow = state => state.previewerWindow;